import { css } from "styled-components"

import { Color, LineHeight, SpacingSize, TextSize, Transition } from "./style-mixins"

interface StyledProps {
  disabled: boolean
  styledBySize: string
  variant?: string
}

export const StyledBySize = {
  Medium: `
    padding: ${SpacingSize.M}px 0
    font-size: ${TextSize.M}px
  `,
  Small: `
    padding: 11px 0
    font-size: ${TextSize.S}px
  `,
}

export const ButtonStyle = css<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${Color.White};
  line-height: ${LineHeight["2XS"]}%;
  text-decoration: none;
  border-radius: 24px;
  width: 100%;
  ${Transition.Hover};
  ${({ disabled }) => css`
    pointer-events: ${disabled ? "none" : "auto"};
    background-color: ${disabled ? Color.BorderGray : Color.Primary};
    cursor: ${disabled ? "default" : "pointer"};
    ${disabled &&
    `
      color: ${Color.LightGray};
    `}
    &:hover {
      background-color: ${disabled ? Color.BorderGray : Color.PrimaryDark};
    }
  `};
  ${({ styledBySize }) => css`
    ${styledBySize}
  `};
  ${({ variant, disabled }: StyledProps) => css`
    ${!disabled &&
    variant === "outlined" &&
    css`
      color: ${Color.Primary};
      background-color: ${Color.White};
      border: 1px solid ${Color.Primary};
      &:hover {
        background-color: ${Color.BackgroundPrimary};
      }
    `}
  `};
`
